// import fetchWrapper from "../useFetch";
// import { pull } from "lodash";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const walkthroughUserUpdate = async (data) => {
  const response = await fetch(
    // `${process.env.NEXT_PUBLIC_BASE_CMS}/api/user/walkthrough/update/user/${id}`,
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/user/walkthrough/update/user`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRFToken": "",
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );

  return response;
};

// /api/store/walkthrough/create

export const walkthroughStoreCreate = async (data) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/create`,
    // `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/create`,
    {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        // "Content-Type": "application/json",
        // "X-CSRF-Token": cookies.get("boho_csrf"),
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRFToken": "",
        Cookie: `boho_session=${cookies.get("boho_session")}`,
      },
      body: new URLSearchParams(data),
      // body: JSON.stringify(data),
      credentials: "include",
    },
  );

  if (response.status === 200) {
    data = await response.json();
    return data;
  }
};

export const walkthroughStoreAboutYouUpdate = async (data, storeId) => {
  if (storeId !== null) {
    data.store_id = storeId;
  }

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/update`,
    {
      method: "PATCH",
      headers: {
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      body: new URLSearchParams(data),
      credentials: "include",
    },
  );
  return response;
};

// TODO: connect the responses to the error messages

export const walkthroughStoreAdditionalLinks = async (data, storeId = null) => {
  if (storeId) {
    data.store_id = storeId;
  }
  await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/links`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );
};

export const walkthroughStoreBrandPics = async (data, storeId = null) => {
  if (storeId) {
    data.store_id = storeId;
  }
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/pictures/brand`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );
  return response;
};

export const walkthroughStoreProductPics = async (data, storeId = null) => {
  if (storeId) {
    data.store_id = storeId;
  }
  await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/pictures/product`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );
};

export const walkthroughCategories = async (data, storeId = null) => {
  if (storeId) {
    data.store_id = storeId;
  }

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/categories`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );

  return response;
};

export const walkthroughCategoriesPayment = async (data, storeId = null) => {
  if (storeId) {
    data.store_id = storeId;
  }

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/walkthrough/categories/payment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );

  return response;
};

export const storeApplicationPaymentWithoutCategories = async (data) => {

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/store/calculated-box/payment`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-CSRFToken": cookies.get("boho_csrf"),
        // "X-CSRF-Token": cookies.get("boho_csrf"),
      },
      // body: new URLSearchParams(data),
      body: JSON.stringify(data),
      credentials: "include",
    },
  );

  return response;
};